/**
 * Encapsula elementos necesarios de una entidad del backend.
 * Una entidad es un recurso de la plataforma con identificador.
 */
class Entity {
    constructor(object) {
        this.object = object;

        return new Proxy(this, {
            get(target, property) {
                if (target[property] !== undefined) {
                    return target[property];
                } else if (target.object && target.object[property] !== undefined) {
                    return target.object[property];
                } else {
                    return null;
                }
            }
        });

    }

    /**
     * Identificador de la entidad
     * 
     * @returns {string|null}
     */
    get id() {
        return this.object?.id ?? null;
    }

    get classification_id() {
        return this.object?.classification_id ?? null;
    }

    get value() {
        return this.object?.value ?? null;
    }

    get name() {
        return this.object?.name ?? null;
    }

    isEmpty() {
        return this.object === null || Object.keys(this.object).length === 0;
    }

    /**
     * Accede a la table pivote del modelo. Por ejemplo, si se llama
     * address.person__address, accederá a esos datos
     */
    get pivot() {
        for (let key in this.object) {
            if (key.includes("__")) {
                return this.object[key];
            }
        }
        return null;
    }
}

export { Entity };